exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".issue-invoice-table[data-v-dadf0462]{width:100%;margin-top:15px}", "", {"version":3,"sources":["/workspace/src/views/project/node-views/ProjectIssueInvoiceView.vue"],"names":[],"mappings":"AACA,sCACE,WAAY,AACZ,eAAiB,CAClB","file":"ProjectIssueInvoiceView.vue","sourcesContent":["\n.issue-invoice-table[data-v-dadf0462] {\n  width: 100%;\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dadf0462","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/project/node-views/ProjectIssueInvoiceView.vue
// module id = 2481
// module chunks = 107 120